import React, { Component } from 'react';
import { fixNumbers } from '../../core/utils';
import service from '../../core/service';


interface IProps {

}

interface IState {
    str:string;
    value:string,
    openModal:boolean,
    startValue:string,
    commissionList:any
    loading:boolean;
  to_date: any,
  from_date: any,
  policy_idinsu: any,
  policy_holder_national_code: any,
  policy_type: any,
  page: number;

}

export class CommmissionController extends Component<IProps, IState> {
    datePickerRef:any;
    
    constructor(props: any) {
         super(props);
        this.datePickerRef = React.createRef();
    }
   
    state: IState = {
        str:"",
        value:"",
        openModal:false,
        startValue:"",
        commissionList:[],
        loading:true,
        to_date: "",
        from_date: "",
    policy_idinsu: "",
    policy_holder_national_code: "",
    policy_type:"",
    page: 1,
    };

    search = async (e:any) => {
        this.setState({ str: e })
    };
    handleChange = (e:any) => {
        this.setState({ value: e.target.value })
    };
    
    
  getList = async () => {
    const {
      from_date,
      policy_idinsu,
      to_date,
      policy_holder_national_code,
      policy_type,
      commissionList
      } = this.state;

    this.setState({ loading: true })
    try {
      const response = await service.Commission.list(this.state.page, {
        from_date: from_date === "" ? null : fixNumbers(from_date.convert()?.format("YYYY-MM-DD")),
        policy_idinsu: policy_idinsu === "" ? null : policy_idinsu,
        to_date: to_date === "" ? null : fixNumbers(to_date.convert()?.format("YYYY-MM-DD")),
        policy_holder_national_code: policy_holder_national_code === "" ? null : policy_holder_national_code,
        policy_type: policy_type === "" ? null : policy_type,
      });
      if (response) {
        this.setState({ commissionList: response?.data?.data, loading: false, openModal: false })
        // return response;
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
  };
  resetTimeOut: string | number | NodeJS.Timeout | undefined;
  resetFilter = () => {
    this.setState({from_date: "",to_date: "",policy_idinsu: "",policy_holder_national_code: "",policy_type: "" }) 

    clearTimeout(this.resetTimeOut);
    this.resetTimeOut = setTimeout(() => {
      this.getList()
    }, 800);
  }
  handleChangeFromDate = (value: any) => {
    this.setState({ from_date: value })

  };

  handleChangeToDate = (value: any) => {
    this.setState({ to_date: value })
  };
  paginationTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    this.setState({ page: value })
    clearTimeout(this.paginationTimeOut);
    this.paginationTimeOut = setTimeout(() => {
      this.getList()
    }, 800);
  }
}
export default CommmissionController;